
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiConnectorOverlap as ObiConnectorOverlapElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-connector-overlap.js';
 
 
 

 
 export const ObiConnectorOverlap = createComponent({
   react: React,
   tagName: 'obi-connector-overlap',
   elementClass: ObiConnectorOverlapElement,
   events: {
     
   }
  });
 
 